export interface Paging {
  pageIndex: number;
  pageSize: number;
  totalRecords: number;
  quickFilterValues: string[];
  items: AppFilterItem[];
  sorting?: AppFilterSorting | null;
  logicalOperator?: string;
}

export interface AppFilter extends Paging {
  virtualShowroomProducts?: boolean;
  draftOnly?: boolean;
  manufacturerIds?: string[];
  categoryIds?: string[];
}

export interface AppFilterItem {
  id?: number | string;
  columnField: string;
  operatorValue: string;
  value: string;
}
export interface AppFilterSorting {
  field: string;
  sort?: "asc" | "desc" | null;
}
export interface ShopifyProductFilter extends Paging {
  quickFilterValues: string[];
  endCursor?: string;
  startCursor?: string;
  items: AppFilterItem[];
  shopifyProductStatus?: string;
}

export interface BigCommerceProductFilter extends Paging {
  quickFilterValues: string[];
  items: AppFilterItem[];
  productStatus?: ProductStatus;
}

export interface ProductFilter extends AppFilter {
  sectionOnly: boolean;
}

export interface ProductManagerFilter extends AppFilter {
  manufacturerCodes?: string[];
}

export interface OrderFilter extends Paging {
  archivedOnly: boolean;
  dmsSetupId?: string;
}
export enum ProductStatus {
  Active,
  Draft,
}
